import { css } from "styled-components";

// Simple breakpoints helper for styled-components
// Usage:
//   ${media.mobile` ...styles... `}
//   ${media.tablet` ...styles... `}
//   ${media.desktop` ...styles... `}

export const breakpoints = {
  mobile: 576, // <= 576px
  tablet: 992, // 577px - 992px
  desktop: 1200, // >= 993px
};

export const media = {
  mobile: (...args) => css`
    @media (max-width: ${breakpoints.mobile}px) {
      ${css(...args)}
    }
  `,
  tablet: (...args) => css`
    @media (min-width: ${breakpoints.mobile + 1}px) and (max-width: ${breakpoints.tablet}px) {
      ${css(...args)}
    }
  `,
  desktop: (...args) => css`
    @media (min-width: ${breakpoints.tablet + 1}px) {
      ${css(...args)}
    }
  `,
};
